define.alias("shared/components/shared/ui/blank-panel", "settings/components/shared/ui/blank-panel");